<template>
    <div ref="charts"  >
    </div>
</template>

<script>
  import * as echarts from 'echarts';
  export default {
    name: 'ChartsType1',
    props:{
      xData:{
        type:Array,
        default: ()=>{
          return []
        }
      },
      xIdData:{
        type:Array,
        default: ()=>{
          return []
        }
      },
      xValueData:{
        type:Array,
        default: ()=>{
          return []
        }
      },
      xLabelData:{
        type:Array,
        default: ()=>{
          return []
        }
      },
    },
    data(){
      return {
        myChart:null,
        app:{},
      }
    },
    watch : {
      xData(){
        this.setOption()
      }
    },
    mounted(){
      this.initChart()
      this.setOption()
    },
    methods:{
      initChart(){
        const chartDom = this.$refs.charts
        this.myChart = echarts.init(chartDom);
        this.app.config = {
          rotate: 90,
          align: 'left',
          verticalAlign: 'middle',
          position: 'insideBottom',
          distance: 15,
          onChange: function () {

          }
        };
        const posList = [
          'left',
          'right',
          'top',
          'bottom',
          'inside',
          'insideTop',
          'insideLeft',
          'insideRight',
          'insideBottom',
          'insideTopLeft',
          'insideTopRight',
          'insideBottomLeft',
          'insideBottomRight'
        ];
        this.app.configParameters = {
          rotate: {
            min: -90,
            max: 90
          },
          align: {
            options: {
              left: 'left',
              center: 'center',
              right: 'right'
            }
          },
          verticalAlign: {
            options: {
              top: 'top',
              middle: 'middle',
              bottom: 'bottom'
            }
          },
          position: {
            options: posList.reduce(function (map, pos) {
              map[pos] = pos;
              return map;
            }, {})
          },
          distance: {
            min: 0,
            max: 100
          }
        };
      },
      setOption(){
        if(!this.xValueData || !this.xValueData.length){
          return
        }
        const xValueData = []
        this.xValueData.forEach((item)=>{
          const xValueItemz = {
            name: item.text ,
            // barWidth: 10,
            type: 'bar',
            label: {
              show: true,
              position: this.app.config.position,
              distance: this.app.config.distance,
              align: this.app.config.align,
              verticalAlign: this.app.config.verticalAlign,
              rotate: this.app.config.rotate,
              formatter: '{c} ',
              fontSize: 16,
              rich: {
                name: {}
              },
            },
            emphasis: {
              focus: 'series'
            },
            data:item.value || 0
          }
          xValueData.push(xValueItemz)
        })

        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: this.xLabelData
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: { show: true },
              dataView: { show: true, readOnly: false },
              magicType: { show: true, type: ['line', 'bar', 'stack'] },
              restore: { show: true },
              saveAsImage: { show: true }
            }
          },
          xAxis: [
            {
              type: 'category',
              axisTick: { show: false },
              data: this.xData
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: xValueData
        };
        this.myChart.setOption(option);
      }
    }
  }
</script>

<style scoped>

</style>